import { css, html } from 'lit'

import RefreshButton from '../../../../shared/components/refresh-button.js'
import Web3Mixin from '../../../utilities/web3/Web3Mixin.js'
import MovingBlocksLoaderElement from '../../shared/moving-blocks-loader/moving-blocks-loader.js'

class WalletListElement extends Web3Mixin {
  static properties = {
    ...super.properties,
    wallets: { type: Object },
    selectedAccount: { type: Object },
    refreshing: { type: Boolean },
  }

  constructor() {
    super()
    /** @type {UserWallet[]} */
    this.wallets = []

    this.selectedAccount = null
    this.refreshing = false
  }

  connectedCallback() {
    super.connectedCallback()
  }

  refresh() {
    this.refreshing = true
    this.wallets = []
    setTimeout(() => {
      window.Globals.onUpdate(
        (
          /** @type {CustomEvent} */ { detail: { selectedAccount, wallets } }
        ) => {
          this.selectedAccount = selectedAccount
          this.wallets = wallets
          this.refreshing = false
          window.location.reload()
        }
      )
    }, 2000)
  }

  render() {
    return html`
      <span>
        ${(this.wallets || []).map((w) => {
          return html`<div>
            <wallet-card
              .selected=${this.selectedAccount}
              id=${w.address}
              .wallet=${w}
            ></wallet-card>
          </div> `
        })}
      </span>
      <div class="refresh-button-container">
        <button @click=${this.refresh} class="refresh-button">
          ${this.refreshing
            ? html`<moving-blocks-loader></moving-blocks-loader>`
            : 'Refresh Wallets'}
        </button>
      </div>
    `
  }

  static styles = css`
    div {
      margin-bottom: 16px;
    }
    span {
      height: 80px;
    }
    .refresh-button-container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: var(--DialogueHeightLarge, 260px);
      padding: 10px;
      margin: auto auto 16px auto;
      border-radius: 8px;
      background: var(--Color, #fff);
      border: 2px solid var(--white-2);
    }
    .refresh-button {
      background-color: transparent;
      border: none;
      cursor: pointer;
      color: var(--kula-grey-1);
      font-size: 12px;
      font-weight: 300;
      text-align: center;
      border-radius: 8px;
      background: var(--Color, #fff);
    }
  `
}

customElements.define('wallet-list', WalletListElement)
export default WalletListElement
